import { SectionHeader } from "./SectionHeader";
import type { Theme } from "./theme";

const ITEMS = [
  "roles feel niche or difficult to assess",
  "internal teams lack time or bandwidth",
  "hiring managers want speed",
  "there is limited confidence in direct hiring",
];

export function WhyAgencies({ theme }: { theme: Theme }) {
  return (
    <section style={{ padding: "120px 0", borderTop: `1px solid ${theme.border}` }}>
      <SectionHeader
        theme={theme}
        kicker="The reality"
        title="Why companies still default to agencies."
      />
      <div
        style={{
          maxWidth: 1200,
          margin: "0 auto",
          padding: "0 40px",
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 64,
        }}
      >
        <div>
          <p
            style={{
              fontSize: 17,
              color: theme.fgMute,
              lineHeight: 1.6,
              margin: "0 0 24px",
            }}
          >
            Even with internal TA teams, organisations rely on agencies when:
          </p>
          <ul
            style={{
              listStyle: "none",
              padding: 0,
              margin: 0,
              display: "flex",
              flexDirection: "column",
              gap: 0,
            }}
          >
            {ITEMS.map((t, i) => (
              <li
                key={t}
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: 16,
                  padding: "16px 0",
                  borderBottom: `1px solid ${theme.border}`,
                  fontSize: 16,
                  color: theme.fg,
                }}
              >
                <span
                  style={{
                    fontFamily: theme.mono,
                    fontSize: 12,
                    color: theme.fgMute,
                    minWidth: 24,
                    marginTop: 4,
                  }}
                >
                  0{i + 1}
                </span>
                {t}
              </li>
            ))}
          </ul>
        </div>
        <div
          style={{
            padding: 32,
            background: theme.surface,
            border: `1px solid ${theme.border}`,
            borderRadius: theme.radius * 1.5,
            position: "relative",
            alignSelf: "start",
          }}
        >
          <div
            style={{
              fontSize: 12,
              letterSpacing: 0.5,
              textTransform: "uppercase",
              color: theme.fgMute,
              marginBottom: 16,
            }}
          >
            The real purchase
          </div>
          <div
            style={{
              fontSize: 28,
              fontWeight: 600,
              letterSpacing: -0.6,
              color: theme.fg,
              lineHeight: 1.2,
              marginBottom: 20,
            }}
          >
            Most companies are not buying access to talent.
          </div>
          <div
            style={{
              fontSize: 28,
              fontWeight: 600,
              letterSpacing: -0.6,
              color: theme.accentFg,
              lineHeight: 1.2,
            }}
          >
            They are buying speed and confidence.
          </div>
          <div style={{ position: "absolute", top: 24, right: 24, display: "flex", gap: 4 }}>
            <span style={{ width: 6, height: 6, borderRadius: 3, background: theme.accent }} />
            <span
              style={{
                width: 6,
                height: 6,
                borderRadius: 3,
                background: theme.accent,
                opacity: 0.5,
              }}
            />
            <span
              style={{
                width: 6,
                height: 6,
                borderRadius: 3,
                background: theme.accent,
                opacity: 0.2,
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
